/**
 * 主应用组件
 * 整合所有页面和组件
 */
import { useState, useEffect } from 'react';
import { authAPI } from './services/api';
import Header from './components/Header';
import QAPanel from './components/QAPanel';
import DocumentManager from './components/DocumentManager';
import LoginPage from './components/LoginPage';
import RegisterPage from './components/RegisterPage';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentPage, setCurrentPage] = useState('login'); // login, register, main
  const [activeTab, setActiveTab] = useState('qa');
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // 检查登录状态
  useEffect(() => {
    const checkAuth = async () => {
      const pathname = window.location.pathname;
      
      if (authAPI.isLoggedIn()) {
        try {
          const response = await authAPI.getCurrentUser();
          setUser(response.data);
          setIsLoggedIn(true);
          setCurrentPage('main');
        } catch {
          authAPI.clearLoginInfo();
          setIsLoggedIn(false);
          // 根据URL路径决定显示登录还是注册页面
          setCurrentPage(pathname === '/register' ? 'register' : 'login');
        }
      } else {
        // 如果没有登录，直接根据URL路径决定显示哪个页面，不需要调用getCurrentUser
        setIsLoggedIn(false);
        if (pathname === '/register') {
          setCurrentPage('register');
        } else if (pathname === '/login' || pathname === '/') {
          setCurrentPage('login');
        } else {
          // 其他路径重定向到登录
          window.location.href = '/login';
        }
      }
      setLoading(false);
    };
    checkAuth();
  }, []);

  const handleLoginSuccess = () => {
    const currentUser = authAPI.getCurrentUserFromStorage();
    setUser(currentUser);
    setIsLoggedIn(true);
    setCurrentPage('main');
  };



  const handleRegisterSuccess = () => {
    setCurrentPage('login');
  };

  const handleLogout = () => {
    authAPI.clearLoginInfo();
    setUser(null);
    setIsLoggedIn(false);
    setCurrentPage('login');
  };

  const handleNavChange = (page) => {
    if (page === 'login') {
      setCurrentPage('login');
    } else if (page === 'register') {
      setCurrentPage('register');
    }
  };

  // 加载中状态
  if (loading) {
    return (
      <div className="min-h-screen grid-bg flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  // 登录/注册页面
  if (!isLoggedIn) {
    if (currentPage === 'register') {
      return <RegisterPage onRegisterSuccess={handleRegisterSuccess} />;
    }
    return <LoginPage onLoginSuccess={handleLoginSuccess} />;
  }

  // 主应用页面
  return (
    <div className="min-h-screen grid-bg w-full">
      {/* 背景装饰 */}
      <div className="fixed inset-0 tech-gradient-bg pointer-events-none" />
      
      <div className="relative z-10 flex flex-col min-h-screen w-full">
        <Header 
          activeTab={activeTab} 
          setActiveTab={setActiveTab}
          user={user}
          onLogout={handleLogout}
          onNavChange={handleNavChange}
        />
        
        <main className="flex-1 max-w-6xl mx-auto px-4 py-6 w-full">
          {activeTab === 'qa' && <QAPanel />}
          {activeTab === 'documents' && <DocumentManager userRole={user?.role || 'user'} />}
        </main>
        
        <footer className="glass-card mx-4 mb-4">
          <div className="px-6 py-3 text-center text-gray-400 text-sm">
            <p className="gradient-text">巨猿人知识库问答系统 - AI 驱动的智能问答助手</p>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default App;
